"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
require("core-js/modules/esnext.json.parse.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _app = require("@/store/modules/app");
var _admin = require("@/store/modules/admin");
var _index = _interopRequireDefault(require("@/components/Breadcrumb/index.vue"));
var _index2 = _interopRequireDefault(require("@/components/ErrorLog/index.vue"));
var _index3 = _interopRequireDefault(require("@/components/Hamburger/index.vue"));
var _index4 = _interopRequireDefault(require("@/components/HeaderSearch/index.vue"));
var _index5 = _interopRequireDefault(require("@/components/LangSelect/index.vue"));
var _index6 = _interopRequireDefault(require("@/components/Screenfull/index.vue"));
var _index7 = _interopRequireDefault(require("@/components/SizeSelect/index.vue"));
var _eventBus = require("@/event-bus");
var _leadsNotifications = require("@/api/notifications/leads-notifications");
var _utils = require("@/utils");
let default_1 = class extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.loggedInUser = _admin.AdminModule.name || null;
    this.notificationCount = _admin.AdminModule.notificationCount;
    this.showNotificationSideBar = false;
    this.notificationData = [];
    this.loadingNotifications = false;
    // Yansh remove required
    this.notificationSound = new Audio(require('@/assets/notification.mp3'));
    this.notificationsShownInPopup = [];
    this.notificationPopupTracker = {};
  }
  onAvatarError(event) {
    const img = event.target;
    img.src = '/default-avatar.png';
  }
  created() {
    const updateNotificationCount = (notificationData = {}) => {
      this.notificationCount = notificationData.notificationCount || 0;
      // handle negative
      if (this.notificationCount < 0) {
        this.notificationCount = 0;
      }
      if (document.title.includes('(')) {
        const title = document.title.split(' (');
        document.title = title[0];
        document.title += ` (${this.notificationCount})`;
      } else {
        document.title += ` (${this.notificationCount})`;
      }
      //  loop over notificationData.notifications and show notification
      if (notificationData.notifications) {
        let count = 0;
        if (notificationData.notifications.length > 0) {
          // Play notification sound
          this.notificationSound.play();
        }
        // @yansh
        // get ids
        const latestIds = new Set(notificationData.notifications.map(notification => notification.id));
        // @yansh
        // Filter out ids from tracker that are not in latestIds
        const missingIds = Object.keys(this.notificationPopupTracker).map(Number) // Convert keys from string to number
        .filter(id => !latestIds.has(id));
        // @yansh
        // check if has missingIds
        if (missingIds.length) {
          missingIds.forEach(notificationId => {
            // close opened pop up as notification is read
            this.notificationPopupTracker[notificationId].close();
            // delete from tracker
            delete this.notificationPopupTracker[notificationId];
          });
        }
        // loop over
        notificationData.notifications.forEach(notification => {
          if (count > 5) {
            return false; // break
          }
          if (this.notificationsShownInPopup.indexOf(notification.id) > -1) {
            return true; // continue
          }
          // show notification
          // @yansh
          this.notificationPopupTracker[notification.id] = this.$notify({
            title: notification.title,
            message: '<small>' + notification.message + '</small>',
            type: 'warning',
            duration: 7500,
            showClose: true,
            dangerouslyUseHTMLString: true,
            onClick: async () => {
              // delete from tracker
              delete this.notificationPopupTracker[notification.id];
              await (0, _leadsNotifications.markNotificationAsRead)(notification.id);
              await this.fetchNotificationsData();
              const response = await (0, _leadsNotifications.getUnreadLeadsNotifications)({});
              _eventBus.EventBus.$emit('updated-notification', response);
              // redirect to respective page, notification.page & notification.params
              // if (notification.page) {
              //   let page = ''
              //   if (notification.page === 'followup') {
              //     const params = JSON.parse(notification.params)
              //     page = 'Follow-up'
              //   }
              //   this.$router.push({
              //     name: page,
              //     params: JSON.parse(notification.params) || {}
              //   })
              // }
            }
          });
          this.notificationsShownInPopup.push(notification.id);
          count++;
        });
      }
      // if (count > 0) {
      //   this.$notify({
      //     title: "",
      //     message: `You have ${count} new notifications.Please check`,
      //     type: "success",
      //     duration: 2000,
      //   });
      // }
    };
    _eventBus.EventBus.$on('updated-notification', updateNotificationCount);
  }
  async markNotificationRead(notification) {
    if (!notification.isRead) {
      await (0, _leadsNotifications.markNotificationAsRead)(notification.id);
    }
    const response = await (0, _leadsNotifications.getUnreadLeadsNotifications)({});
    _eventBus.EventBus.$emit('updated-notification', response);
    // redirect to respective page, notification.page & notification.params
    if (notification.page) {
      let page = '';
      if (notification.page === 'followup') {
        const params = JSON.parse(notification.params);
        page = 'Follow-up';
      }
      this.$router.push({
        name: page,
        params: JSON.parse(notification.params) || {}
      });
    }
    this.showNotificationSideBar = false;
  }
  get role() {
    if (_admin.AdminModule.roles.length) {
      return _admin.AdminModule.roles.toString();
    } else {
      return null;
    }
  }
  get sidebar() {
    return _app.AppModule.sidebar;
  }
  get device() {
    return _app.AppModule.device.toString();
  }
  get avatar() {
    // Yansh: send avatar or profile picture from nest to set here
    if (_admin.AdminModule.avatar.length === 0) {
      return '/favicon.ico';
    }
    return _admin.AdminModule.avatar;
  }
  toggleSideBar() {
    _app.AppModule.ToggleSideBar(false);
  }
  async fetchNotificationsData() {
    try {
      this.loadingNotifications = true;
      const response = await (0, _leadsNotifications.getLeadsNotifications)((0, _utils.getQuery)({
        page: 0,
        limit: 10,
        adminId: _admin.AdminModule.id,
        filter: {
          adminId: '$eq'
        }
      }));
      this.notificationData = response.data;
      this.showNotificationSideBar = true;
    } catch (error) {
      this.notificationData = null;
    } finally {
      this.loadingNotifications = false;
    }
  }
  async logout() {
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    switch (_admin.AdminModule.userType) {
      case 'Admin':
        await _admin.AdminModule.LogOut();
        this.$router.push('/login');
        break;
      default:
        break;
    }
  }
};
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'Navbar',
  components: {
    Breadcrumb: _index.default,
    ErrorLog: _index2.default,
    Hamburger: _index3.default,
    HeaderSearch: _index4.default,
    LangSelect: _index5.default,
    Screenfull: _index6.default,
    SizeSelect: _index7.default
  }
})], default_1);
var _default = exports.default = default_1;